import './App.css';
import Menu from './components/Menu';
import Tours from './components/Tours';
import Home from './components/Home';
import TourDetails from './components/TourDetails';
import DayRideMap from './components/DayRideMap';
import Container from 'react-bootstrap/Container';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';

import { auth, db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useAuthState } from "react-firebase-hooks/auth";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser, unsetUser } from './features/userSlice';
import useRider from './utils/useRider';

function App() {
  const [error, setError] = useState();
  useRider();
  const dispatch = useDispatch();
  console.log('Environment:',process.env.NODE_ENV);
  
  useAuthState(auth, {
    onUserChanged: (user) => {
      // console.log('Came to onUserChanged', user);
      if (user) {
        const userRef = doc(db, `/users/${user.uid}`);
        getDoc(userRef)
          .then(userSnapshot => {
            if (userSnapshot.exists()) {
              processExistingUser(userSnapshot)
            } else {
              processNewUser(user);
            }
          })
          .catch(err => {
            setError(`Error getting existing user or setting new user: ${err.message}`);
            console.error(err);
          })
      } else {
        dispatch(unsetUser()); //reset state
      }
    }
  });

  const setAppState = (user) => {
    dispatch(setUser(user));
  }

  const processExistingUser = (userSnapshot) => {
    const {latestRide, featuredTour, ...userDoc} = userSnapshot.data();
    // console.log(userDoc);
    // console.log('Setting user redux state to: ', {...userDoc, uid: userSnapshot.id, latestRideId: latestRide?.id, featuredTourId: featuredTour?.id});
    setAppState({
      ...userDoc, 
      uid: userSnapshot.id, 
      latestRideId: latestRide?.id,
      featuredTourId: featuredTour?.id
    });
  }

  const processNewUser = (user) => {
    //create new db user
    const newUser = {
      authProvider: 'google',
      email: user.email,
      name: user.displayName,
      photoURL: user.photoURL,
      showRides: false
    }
    setDoc(doc(db, `/users/${user.uid}`), newUser)
      .then(() => {
        setAppState({...newUser, uid: user.uid});
      })
      .catch(err => {
        setError(`Error: ${err.message}`);
        console.error(err);
      })
  }

  return (
    <BrowserRouter>
      <Menu />
      <div className='app'>
        {error && <div>{error}</div>}
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<Home />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/tours/:tourId" element={<TourDetails />}/>
            <Route path="/dayRide/:rideId" element={<DayRideMap />}/>
            <Route path="/latestRide" element={<DayRideMap />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  )
}

const NotFound = () => {
  return (<Container>Not Found: 404! Please use application navigation. </Container>);
};

export default App;
